import './DataForm.css';
import Modal from '../../../../../Modal/Modal.jsx';
import {useEffect, useState} from "react";
import Validator from "../../../../../../Validator.js";
import InformationWidget from "../../../../../InformationWidget/InformationWidget.jsx";
import {createDeliveryAddress, editDeliveryAddress} from "../../../../../../CustomerHandler.js";

export default function DataForm({ setDisplayForm, setEditID, editID, editData, refreshData }) {

    const defaultState = { name: "", street: "", postal: "", city: "", phone: "", country: "" };

    const [formData, setFormData] = useState(defaultState);

    useEffect(() => {
        if (editID !== null && editData) {
            setFormData({ ...editData });
        }
    }, [editID, editData]);

    const [isFormValid, setIsFormValid] = useState({
        name: true, street: true, postal: true, city: true, phone: true, country: true
    });

    const validateForm = () => {
        const newFormValid = {
            name: Validator.isEmpty(formData.name) ? "Imię nie może być puste" : true,
            street: Validator.isEmpty(formData.street) ? "Ulica nie może być pusta" : true,
            postal: Validator.isEmpty(formData.postal)
                ? "Kod pocztowy nie może być pusty"
                : Validator.isPostalCode(formData.postal) ? true : "Kod pocztowy jest niepoprawny",
            city: Validator.isEmpty(formData.city) ? "Miasto nie może być puste" : true,
            phone: Validator.isEmpty(formData.phone)
                ? "Numer telefonu nie może być pusty"
                : Validator.isPhone(formData.phone) ? true : "Numer telefonu jest niepoprawny",
            country: Validator.isEmpty(formData.country) ? "Kraj nie może być pusty" : true
        };

        setIsFormValid(newFormValid);
        return Object.values(newFormValid).every(val => val === true);
    };

    const sendForm = async () => {
        if (!validateForm()) return;

        const token = sessionStorage.getItem("customerAccessToken");
        if (!token) return;

        if (editID) {
            await editDeliveryAddress(token, editID, formData);
        } else {
            await createDeliveryAddress(token, formData);
        }

        refreshData?.();
        handleClose();
    };

    const handleClose = () => {
        setDisplayForm(false);
        setEditID(null);
    };

    return (
        <Modal isOpen={true} onClose={handleClose}>
            <div className="form-container" onClick={e => e.stopPropagation()}>
                <div className="form-top">
                    <span className="form-label">
                        {editID === null ? 'Dodaj adres dostawy' : 'Edytuj adres dostawy'}
                    </span>
                    <div
                        className="form-close-btn"
                        onClick={handleClose}
                    >
                        <img loading="lazy" src='/images/close-icon.webp' alt="" />

                    </div>
                </div>

                <div className="form-bottom">
                    {["name", "street", "postal", "city", "phone", "country"].map((field) => (
                        <div className="form-input-wrapper" key={field}>
                            <input
                                placeholder={getPlaceholder(field)}
                                className="form-input"
                                value={formData[field] || ""}
                                onChange={e => setFormData({ ...formData, [field]: e.target.value })}
                            />
                            {isFormValid[field] !== true && (
                                <InformationWidget text={isFormValid[field]} />
                            )}
                        </div>
                    ))}
                    <div className="form-save-btn" onClick={sendForm}>Zapisz</div>
                </div>
            </div>
        </Modal>
    );
}

const getPlaceholder = (field) => {
    const map = {
        name: "Imię i nazwisko / Nazwa firmy",
        street: "Ulica i numer",
        postal: "Kod pocztowy",
        city: "Miejscowość",
        phone: "Numer telefonu",
        country: "Kraj"
    };
    return map[field] || field;
};
